import React from "react";
import PropTypes from "prop-types";

// components:
import Tooltip from "core/Tooltip";
import Button from "core/Button";
import SrOnly from "core/SrOnly";

// icons:
import Add from "core/ReusableIcons/Add";
import Lock from "core/ReusableIcons/Lock";

// styles:
import colors from "core/colors";
import { IconContainer, ButtonContainer, ButtonContent } from "./styles";

// links:
import { PRICING } from "data/links";

const FooterContent = ({ isFreeUser, handleFooterButtonClick }) => {
    const unlockTooltipText = (
        <>
            Get unlimited kits with{" "}
            <a href={`${PRICING}#icons`} target="_blank">
                NounPro
            </a>
        </>
    );

    const iconFillColor = isFreeUser
        ? colors.secondary.oolong
        : colors.secondary.orca;

    const sharedButtonProps = {
        styleType: "outline",
        width: "100%",
        justifyContent: isFreeUser ? "space-between" : "flex-start",
        iconPosition: "left"
    };

    const sharedButtonContents = (
        <ButtonContent>
            <Add fillColor={iconFillColor} />
            Add to a New Kit
        </ButtonContent>
    );

    return isFreeUser ? (
        <ButtonContainer>
            <Tooltip message={unlockTooltipText} textAlignment="center">
                <Button isDisabled {...sharedButtonProps}>
                    {sharedButtonContents}

                    <IconContainer>
                        <Lock fillColor={iconFillColor} />
                        <SrOnly>{unlockTooltipText}</SrOnly>
                    </IconContainer>
                </Button>
            </Tooltip>
        </ButtonContainer>
    ) : (
        <Button onClick={handleFooterButtonClick} {...sharedButtonProps}>
            {sharedButtonContents}
        </Button>
    );
};

FooterContent.propTypes = {
    isFreeUser: PropTypes.bool.isRequired,
    handleFooterButtonClick: PropTypes.func.isRequired
};

export default FooterContent;
